import styles from "./UsersLoginsPage.module.css";
import React, {useEffect, useState} from "react";
import {Administrator} from "../../services/models/administrator";
import {SubUser} from "../../services/models/sub_user";
import {toast} from "react-toastify";
import * as SubUserApi from "../../services/network/sub_user-api";
import Select from "react-select";
import {countUserLogins, getExcelData, getLastLogin} from '../../services/network/userLogs-api';

interface UsersLoginsPageProps {
    user: Administrator | SubUser | null;
}

function isAdmin(obj: any): obj is Administrator {
    return obj && obj.role === undefined;
}


export const UsersLoginsPage: React.FC<UsersLoginsPageProps> = ({user}) => {


    const [selectedUser, setSelectedUser] = React.useState<string | null>(null);

    const [subUsers, setSubUsers] = useState<SubUser[]>([]);
    useEffect(() => {
        async function loadData() {
            try {
                const subUsersData = await SubUserApi.getSubUsers();
                setSubUsers(subUsersData);

            } catch (error) {
                console.error(error);
                toast.error("Ошибка при получении списка пользователей");
            }
        }

        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const userOptions = subUsers.map(user => ({
        value: user.id,
        label: user.full_name || user.email
    }));

    function getDefaultDates() {
        const today = new Date();
        const endDate = today.toISOString().slice(0, 10);
        let prevMonth = today.getMonth() - 1;
        let prevYear = today.getFullYear();
        if (prevMonth < 0) {
            prevMonth = 11;
            prevYear--;
        }
        // Корректировка дня месяца (например, 31 → 30/28/29)
        const maxDay = new Date(prevYear, prevMonth + 1, 0).getDate();
        const day = Math.min(today.getDate(), maxDay);
        const startDate = new Date(prevYear, prevMonth, day).toISOString().slice(0, 10);
        return {startDate, endDate};
    }

    const [{startDate, endDate}, setDates] = React.useState(getDefaultDates());

    const isUserSelected = Boolean(selectedUser);
    const isPeriodSelected = Boolean(startDate && endDate);

    // Состояния загрузки для кнопок
    const [loadingCount, setLoadingCount] = React.useState(false);
    const [loadingLast, setLoadingLast] = React.useState(false);
    const [content, setContent] = React.useState<React.ReactNode>(null);

    // Обработчик для кнопки "Кол-во входов за период"
    const handleCountClick = async () => {
        if (!selectedUser || !startDate || !endDate) return;
        setContent(null);
        setLoadingCount(true);
        try {
            const {data} = await countUserLogins({userId: selectedUser, from: startDate, to: endDate});
            setContent(
                <div>
                    <div>Входов за период: {data.total ?? 0}</div>
                    <div className={styles.tableWrapper}>
                        <div className={`${styles.table} ${styles.tableOP}`}>
                            <div className={styles.tableBody}>
                                <div className={styles.rowHead}>
                                    <div className={styles.col}>Дата и время</div>
                                    <div className={styles.col}>IP</div>
                                    <div className={styles.col}>Устройство</div>
                                </div>
                                {Array.isArray(data.logins) && data.logins.length > 0 &&
                                    data.logins.map((log: any) => (
                                        <div key={log._id} className={styles.row}>
                                            <div className={styles.col}>
                                                {log.loginAt}
                                            </div>
                                            <div className={styles.col}>
                                                {log.ip}
                                            </div>
                                            <div className={styles.col}>
                                                {log.device}
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </div>
                    </div>
                </div>
            );
        } catch (e) {
            setContent(<div>Ошибка при получении количества входов</div>);
        }
        setLoadingCount(false);
    };

    // Обработчик для кнопки "Последний логин"
    const handleLastLoginClick = async () => {
        if (!selectedUser) return;
        setContent(null);
        setLoadingLast(true);
        try {
            const {data} = await getLastLogin(selectedUser);
            if (data && data.loginAt) {
                setContent(
                    <div>
                        <div>Последний вход: {data.loginAt}</div>
                        <div>IP: {data.ip}</div>
                        <div>Device: {data.device}</div>
                    </div>
                );
            } else {
                setContent(<div>Нет данных о входах</div>);
            }
        } catch (e) {
            setContent(<div>Ошибка при получении последнего входа</div>);
        }
        setLoadingLast(false);
    };
    const handlerExcel = async ()=> {
        try {
            const {data} = await getExcelData();
            if (!data || !Array.isArray(data)) {
                toast.error("Нет данных для экспорта");
                return;
            }
            // Импортируем xlsx только здесь, чтобы не тянуть в основной бандл
            const XLSX = await import('xlsx');

            // Формируем массив для Excel: первая строка — шапка
            const excelData = [
                ['Имя пользователя', 'Последний логин', 'Кол-во входов'],
                ...data.map((item: { userName: string, lastLogin: string | null, count: number }) => [
                    item.userName,
                    item.lastLogin || '',
                    item.count
                ])
            ];

            // Вычисляем ширины столбцов по максимальной длине содержимого
            const colWidths = excelData[0].map((_, colIdx) =>
                ({
                    wch: Math.max(
                        ...excelData.map(row => String(row[colIdx] ?? '').length),
                        10 // минимальная ширина
                    )
                })
            );

            const worksheet = XLSX.utils.aoa_to_sheet(excelData);
            worksheet['!cols'] = colWidths;

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'User Logins');
            XLSX.writeFile(workbook, `user-logins-${new Date().toISOString().slice(0,10)}.xlsx`);
        } catch (e) {
            console.error(e);
            toast.error("Ошибка при загрузке данных для эксель")
        }
    }
    return (
        <div className={styles.reportPage}>
            <button onClick={handlerExcel}>excel</button>
            <div style={{maxWidth: 400, margin: '0 auto 24px auto'}}>
                <label style={{fontWeight: 500, marginBottom: 8, display: 'block'}}>Выберите пользователя:</label>
                <Select
                    options={userOptions}
                    value={userOptions.find(option => option.value === selectedUser) || null}
                    onChange={option => setSelectedUser(option ? option.value : null)}
                    isSearchable
                    placeholder="Выберите пользователя..."
                    noOptionsMessage={() => "Пользователь не найден"}
                />
            </div>
            <div style={{maxWidth: 400, margin: '0 auto 24px auto', display: 'flex', gap: 16, alignItems: 'center'}}>
                <div>
                    <label>Дата начала:</label><br/>
                    <input
                        type="date"
                        value={startDate}
                        max={endDate}
                        onChange={e => setDates(d => ({...d, startDate: e.target.value}))}
                    />
                </div>
                <div>
                    <label>Дата окончания:</label><br/>
                    <input
                        type="date"
                        value={endDate}
                        min={startDate}
                        max={new Date().toISOString().slice(0, 10)}
                        onChange={e => setDates(d => ({...d, endDate: e.target.value}))}
                    />
                </div>
            </div>
            <div style={{maxWidth: 400, margin: '0 auto', display: 'flex', gap: 16}}>
                <button
                    disabled={!(isUserSelected && isPeriodSelected) || loadingCount}
                    onClick={handleCountClick}
                >
                    {loadingCount ? 'Загрузка...' : 'Кол-во входов за период'}
                </button>
                <button
                    disabled={!isUserSelected || loadingLast}
                    onClick={handleLastLoginClick}
                >
                    {loadingLast ? 'Загрузка...' : 'Последний логин'}
                </button>
            </div>
            {content && (
                <div className={styles.contentWrapper}>{content}</div>
            )}
        </div>
    );

};
